import React from "react";
import PropTypes from "prop-types";

const RadioButton = ({
  id,
  name,
  value,
  title,
  defaultChecked,
  register,
  rules,
  ...props
}) => {
  return (
    <div className="radio-btn">
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        {...props}
        {...(register && register(name, rules))}
      />
      <label className="radio-label" htmlFor={id}>
        <span>{title}</span>
      </label>
    </div>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  title: PropTypes.string,
  defaultChecked: PropTypes.bool,
  register: PropTypes.any,
  rules: PropTypes.any,
};

export default RadioButton;
